
<app-dialog
    [header]="dialogHeader"
    [show]="true"
    [hasControls]="true"
    [saveBtnText]="countHeader + ' ' + orderSalesReturnsFormArray?.length + ' Drug' + (orderSalesReturnsFormArray?.length > 1 ? 's' : '')"
    [hideControlsDivider]="true"
    (save)="submitForm()"
    (cancel)="cancel.emit()"
    (onCancelKeyDown)="recordingSale? po.focusInput() : mra.focusInput()"
    (onSubmitKeyDown)="recordingSale? po.focusInput() : mra.focusInput()"
    [scrollable]="true"
    [id]="dialogId"
    maxHeight="98vh"
    #dialog
>
    <div [class.hidden]="!orderSalesReturnsFormArray?.length">
        <div [formGroup]="form" class="controls-container">
            <app-input label="PO Number" *ngIf="recordingSale; else recordingReturn"  
                formControlName="poNumber"
                #po
            ></app-input>
            <ng-template #recordingReturn>
                <app-input label="MRA Number" 
                 formControlName="mra"
                 #mra
                ></app-input>
            </ng-template>
            
            <app-input label="Invoice Number"
                formControlName="invoiceNumber"
            ></app-input>
            <app-datepicker-input label="Ship Date"
                formControlName="shipDate"
                iconName="icon-date-picker"
                [dateMax]="now()"
                (inputTabKeyDown)="transactionDatePicker.focusInput()"
                (afterPickerClosed)="shipDate.focusInput()"
                #shipDate
            ></app-datepicker-input>
            <app-datepicker-input [tabInd]="0"
                class="ml-[8px]"
                label="Transaction Date/Time"
                pickerType="both"
                formControlName="transactionDateDisplayValue"
                (dateTimeChange)="dateTimeChanged($event)"
                (inputTabKeyDown)="datePickerFocusNext()"
                [dateMax]="now()"
                calendarPosition="right"
                #transactionDatePicker>
            </app-datepicker-input>
        </div>
        <app-supplier-buyer-sale-details class="block pb-8"
            (currentBuyerDetailId)="setCurrentBuyerDetailId($event)"
            (currentSupplierDetailId)="setCurrentSupplierDetailId($event)"
            #supplierBuyerDetails>
        </app-supplier-buyer-sale-details>
        <div class="-ml-8 -mr-8">
            <div #fileAttachment [formGroup]="form">
                <app-file-attachment 
                    [files]="files"
                    [fileTypes]="fileTypes"
                    [requiresSignature]="true"
                    [loadFileBeforeReSigning]="false"
                    [csosControl]="form.get('csosNumber')"
                    headerClasses="text-sm"
                    (saveFiles)="saveFiles($event)"
                >
                </app-file-attachment>
            </div>
            <app-generic-write-table *ngIf="orderSalesReturnsFormArray.length"
                [ngStyle]="{'--table-height': 'calc(100vh-200px)'}"
                [formArray]="orderSalesReturnsFormArray" [columns]="columns"
                [useDefaultLocationChangeHandler]="true"
                [isScrollable]="false"
                adNdcClasses="ml-8"
                (addNdc)="addNdcMode = true"
                (rowDeleted)="handleRowDeletedSideEffect($event)"
                (onLastNumberInputKeyupEnter)="handleLastInputTabbing()"
                (onLastInputKeydownTab)="handleLastInputTabbing()"
                #table
            >
            </app-generic-write-table>
        </div>
    </div>
</app-dialog>

<app-dialog *ngIf="addNdcMode || !orderSalesReturnsFormArray?.length"
    [show]="true"
    [header]="'Add new NDC'"
    [hasControls]="true"
    (cancel)="cancelAddNewNdc()"
    [hideSaveButton]="true"
    [hideControlsDivider]="true"
    >
    <app-input-search-scanner 
        class="scanner"
        [autofocus]="true"
        [isInventory]="true"
        (optionSelected)="optionSelected($event)"
        [placeholder]="'Scan barcode (Or search drug name or NDC)'"
        [label]="'Which drug do you want to add?'"
        [active]="true"
        [singleLocationResult]="true"
        [locationsToExclude]="getLocationsToExclude()"
        [searchEmptyInventory]="false"
        #searchScanner
    ></app-input-search-scanner>
</app-dialog>